'use client';

import { useQuery } from '@tanstack/react-query';

import { getGlossaryEntryService, getGlossaryListService } from '@/services/httpServices/GlossaryServices';
import type {
  GetGlossaryEntryServiceConfig,
  GlossaryEntryResponse,
  GlossaryListResponse,
  GlossaryListServiceConfig,
} from '@/services/httpServices/GlossaryServices/types';

import { glossaryEntryByIdKeys, glossaryListKeys } from './glossaryQueryKeys';
import { useQueryConfig } from './useQueryConfig';

export function useGlossaryListQuery(params?: GlossaryListServiceConfig) {
  const { isEnabled } = useQueryConfig();

  return useQuery<GlossaryListResponse>({
    queryKey: glossaryListKeys(params),
    queryFn: async () => {
      if (params === undefined) {
        throw new Error('Params are required');
      }
      return getGlossaryListService(params);
    },
    enabled: isEnabled && params !== undefined,
  });
}

export function useGlossaryEntryByIdQuery(
  params?: GetGlossaryEntryServiceConfig,
  enabled?: boolean,
) {
  const { isEnabled } = useQueryConfig();

  return useQuery<GlossaryEntryResponse>({
    queryKey: glossaryEntryByIdKeys(params),
    queryFn: async () => {
      if (params === undefined) {
        throw new Error('Glossary entry params are required');
      }
      return getGlossaryEntryService(params);
    },
    enabled: isEnabled && (enabled ?? (params !== undefined && params.params?.params.id !== undefined)),
  });
}
